import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-1564820a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg bg-black sticky-top" }
const _hoisted_2 = { class: "container-lg" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Magneto logo",
  class: "img-fluid"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#magnetoNav",
  "aria-controls": "magnetoNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  class: "collapse navbar-collapse justify-content-end",
  id: "magnetoNav"
}
const _hoisted_6 = { class: "navbar-nav my-3 my-lg-0 align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none col-8" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none col-8" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none col-8" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none col-8" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link btn btn-primary",
  target: "_blank",
  href: "https://www.tevo.co.za/all/outdoor/portable-power-stations"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-uppercase py-2 px-4" }, "Shop Online")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "navbar-brand",
        to: {name: 'Home'}
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            class: "nav-link",
            "active-class": "active",
            "aria-current": "page",
            to: {name: 'AboutUs'}
          }, {
            default: _withCtx(() => [
              _createTextVNode("About Us")
            ]),
            _: 1
          }),
          _hoisted_7,
          _createVNode(_component_router_link, {
            class: "nav-link",
            "active-class": "active",
            to: {name: 'ProductRange'}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Product Range")
            ]),
            _: 1
          }),
          _hoisted_8,
          _createVNode(_component_router_link, {
            class: "nav-link",
            "active-class": "active",
            to: {name: 'ProductGuide'}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Product Guide")
            ]),
            _: 1
          }),
          _hoisted_9,
          _createVNode(_component_router_link, {
            class: "nav-link",
            "active-class": "active",
            to: {name: 'ContactUs'}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Contact Us")
            ]),
            _: 1
          }),
          _hoisted_10,
          _hoisted_11
        ])
      ])
    ])
  ]))
}